import { render, staticRenderFns } from "./DateRangeSelector.vue?vue&type=template&id=966e22c6&"
import script from "./DateRangeSelector.vue?vue&type=script&lang=ts&"
export * from "./DateRangeSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports